/* A small, demand-loaded frame window: no autoplay or video seek on touch devices. */
(() => {
  class WatchFrames {
    constructor({base,count=432,fps=24,onFrame}) {
      this.base=base;this.count=count;this.fps=fps;this.onFrame=onFrame;
      this.cache=new Map();this.pending=new Set();this.failures=new Map();
      this.target=0;this.direction=1;this.displayed=-1;this.started=false;
    }
    request(time) {
      const next=Math.max(0,Math.min(this.count-1,Math.round(time*this.fps)));
      if(next!==this.target)this.direction=next>this.target?1:-1;
      this.target=next;this.started=true;this.present();this.pump();
    }
    window() {
      return [...new Set([0,1,2,-1,3,-2].map(offset=>Math.max(0,Math.min(this.count-1,this.target+offset*this.direction))))];
    }
    present() {
      let nearest=this.displayed;
      for(const index of this.cache.keys())if(nearest<0||Math.abs(index-this.target)<Math.abs(nearest-this.target))nearest=index;
      if(nearest<0||nearest===this.displayed)return;
      this.displayed=nearest;this.onFrame(this.cache.get(nearest),nearest/this.fps);
    }
    trim() {
      // Keep at most six decoded frames plus the two active requests (~64 MB).
      const candidates=[...this.cache.keys()].filter(i=>i!==this.displayed).sort((a,b)=>Math.abs(b-this.target)-Math.abs(a-this.target));
      while(this.cache.size>6)this.cache.delete(candidates.shift());
    }
    pump() {
      if(!this.started)return;
      for(const index of this.window()) {
        if(this.pending.size>=2)break;
        if(this.cache.has(index)||this.pending.has(index)||(this.failures.get(index)||0)>=2)continue;
        this.pending.add(index);
        const image=new Image();image.decoding='async';image.fetchPriority=index===this.target?'high':'low';
        const finish=()=>{this.pending.delete(index);this.pump();};
        image.onload=async()=>{
          try{if(image.decode)await image.decode();}catch{/* Loaded pixels remain usable. */}
          this.cache.set(index,image);this.present();this.trim();finish();
        };
        image.onerror=()=>{this.failures.set(index,(this.failures.get(index)||0)+1);finish();};
        image.src=window.KM.asset(`${this.base}/${String(index).padStart(3,'0')}.webp`);
      }
    }
  }
  window.WatchFrames=WatchFrames;
})();
